var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlookLogo = function SvgOutlookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Outlook_Logo_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Outlook_Logo_svg__b",
    width: 22,
    height: 22,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 0H0v22h22z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Outlook_Logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A2767",
    d: "M22 11.55a.54.54 0 0 0-.234-.454h-.002l-.01-.005-7.623-4.851a.96.96 0 0 0-1.143 0l-7.623 4.85-.01.006a.56.56 0 0 0-.159.736.5.5 0 0 0 .171.179l7.624 4.85q.05.036.102.066a.96.96 0 0 0 1.04-.065l7.624-4.851A.54.54 0 0 0 22 11.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0364B8",
    d: "M6.253 8.311h5.003v4.93H6.253zM20.977 3.3V1.045C20.989.481 20.573.014 20.049 0H7.067c-.524.014-.94.481-.928 1.045V3.3l7.675 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M6.14 3.3h5.116v4.95H6.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A8EA",
    d: "M16.372 3.3h-5.116v4.95l5.116 4.95h4.605V8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M11.256 8.25h5.116v4.95h-5.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0364B8",
    d: "M11.256 13.2h5.116v4.95h-5.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14447D",
    d: "M6.253 13.24h5.003v4.482H6.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M16.372 13.2h4.605v4.95h-4.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Outlook_Logo_svg__c)",
    d: "m21.766 11.98-.01.006-7.623 4.61a1.003 1.003 0 0 1-.516.172l-.417-.263a1 1 0 0 1-.102-.063l-7.725-4.74h-.004l-.253-.152v9.33c.004.623.477 1.124 1.056 1.12H20.96c.009 0 .016-.004.025-.004q.185-.013.358-.08a1 1 0 0 0 .144-.08c.035-.022.093-.067.093-.067A1.14 1.14 0 0 0 22 20.88v-9.33c0 .178-.09.342-.234.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A2767",
    d: "M21.591 11.514v.572l-7.971 5.9-8.253-6.28q0-.005-.005-.005l-.757-.49v-.412l.312-.006.66.407.015.006.057.038s7.756 4.758 7.776 4.768l.297.188q.037-.017.082-.034l7.7-4.658z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1490DF",
    d: "m21.766 11.98-.01.007-7.623 4.609a1.002 1.002 0 0 1-1.143 0l-7.624-4.609-.009-.006a.5.5 0 0 1-.24-.43v9.33c.003.622.475 1.123 1.054 1.12h14.774c.579.003 1.051-.498 1.055-1.12v-9.33c0 .178-.09.342-.234.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m14.244 16.527-.115.07a1.001 1.001 0 0 1-.504.177l2.9 3.686 5.06 1.31a1.1 1.1 0 0 0 .32-.43z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m14.76 16.215-.63.381a1.003 1.003 0 0 1-.504.177l1.358 4.027 6.602.969c.26-.21.414-.54.414-.89v-.12z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A8EA",
    d: "M6.186 22h14.757c.227.002.449-.076.632-.22L13.2 16.506a1 1 0 0 1-.102-.063l-7.726-4.74h-.004l-.252-.153v9.299c0 .635.478 1.15 1.07 1.151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.279 5.408V17.14c0 .41-.234.78-.588.935a.8.8 0 0 1-.348.077H5.116V4.95H6.14V4.4h5.204c.517.002.935.452.936 1.008",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.767 5.958v11.731a.95.95 0 0 1-.076.385c-.143.377-.482.624-.86.626H5.116V4.95h5.715a.8.8 0 0 1 .425.115c.313.17.511.515.511.893",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.767 5.958v10.631c-.002.556-.42 1.006-.936 1.01H5.116V4.95h5.715a.8.8 0 0 1 .425.116c.313.17.511.515.511.893",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.256 5.958v10.631c0 .557-.42 1.008-.937 1.01H5.116V4.95h5.203c.518.001.937.453.937 1.009",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Outlook_Logo_svg__d)",
    d: "M.938 4.95h9.38c.518 0 .938.451.938 1.008v10.084c0 .556-.42 1.008-.938 1.008H.938C.42 17.05 0 16.598 0 16.042V5.958C0 5.4.42 4.95.938 4.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.931 9.179c.231-.53.604-.973 1.072-1.273a3.06 3.06 0 0 1 1.702-.458 2.85 2.85 0 0 1 1.575.435c.45.288.812.71 1.042 1.215a4.2 4.2 0 0 1 .366 1.788 4.4 4.4 0 0 1-.376 1.87c-.237.523-.61.96-1.075 1.258a2.96 2.96 0 0 1-1.634.446 2.9 2.9 0 0 1-1.61-.44 2.9 2.9 0 0 1-1.056-1.217 4.1 4.1 0 0 1-.37-1.767c-.01-.64.114-1.276.364-1.857m1.142 2.986c.123.335.332.625.603.837.275.207.605.314.941.305.358.015.71-.095 1.005-.315.267-.211.47-.502.585-.837a3.5 3.5 0 0 0 .187-1.167 3.8 3.8 0 0 0-.176-1.183 1.9 1.9 0 0 0-.567-.872 1.48 1.48 0 0 0-.996-.33c-.343-.01-.68.098-.963.307a1.9 1.9 0 0 0-.614.844 3.6 3.6 0 0 0-.004 2.412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50D9FF",
    d: "M16.372 3.3h4.605v4.95h-4.605z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Outlook_Logo_svg__c",
    x1: 13.558,
    x2: 13.558,
    y1: 11.55,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Outlook_Logo_svg__d",
    x1: 1.955,
    x2: 10.126,
    y1: 4.162,
    y2: 17.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Outlook_Logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgOutlookLogo;